export default function (input: string): string {
	const inputAsNumber = parseFloat(input);
	return Math.round(inputAsNumber * 10000) / 100 + '%';
}
